import script from "./id_val.vue?vue&type=script&setup=true&lang=ts"
export * from "./id_val.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__